import React, { FunctionComponent, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ClinTheme } from '../../ClinTheme'
import { ClinButton } from '../../components/ClinButton'
import { ClinGroup } from '../../components/ClinGroup'
import { ClinModal } from '../../components/ClinModal'
import { ClinSpacer } from '../../components/ClinSpacer'
import { ClinText } from '../../components/ClinText'
import { TypographyVariant } from '../../components/ClinText/ClinText.styles'
import authService from '../../services/AuthService'
import { noop } from '../../utils/noop'

export const SessionSupersededContainer: FunctionComponent = () => {
  const { t } = useTranslation()
  const [isShowing, setIsShowing] = useState<boolean>(false)

  useEffect(() => {
    return authService.onSessionSuperseded(() => setIsShowing(true))
  }, [])

  const handleContinue = () => {
    setIsShowing(false)
    void authService.convergeToCurrentAccount().then(() => noop())
  }

  if (!isShowing) {
    return null
  }

  return (
    <ClinModal
      isOpen={true}
      isDismissible={false}
      zIndex={ClinTheme.zIndices.sessionTimeout}
    >
      <ClinText as="h3" variant={TypographyVariant.H3}>
        {t('common:session_superseded.title')}
      </ClinText>
      <ClinText variant={TypographyVariant.LargeParagraph}>
        {t('common:session_superseded.message')}
      </ClinText>
      <ClinSpacer height={ClinTheme.space[4]} />
      <ClinGroup justifyContent="flex-end">
        <ClinButton variant="primary" onClick={handleContinue}>
          {t('common:session_superseded.continue_btn')}
        </ClinButton>
      </ClinGroup>
    </ClinModal>
  )
}
